import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LogIn } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_84e14be8-c66b-4e50-b378-639bfe417cdf/artifacts/vn03bb90_297950681_1043688306290539_3612407571660205954_n.jpg';

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (location.state?.error) {
      toast.error(location.state.error);
    }
  }, [location.state]);

  const checkAuth = useCallback(async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
        credentials: 'include',
      });
      if (res.ok) {
        navigate('/admin/dashboard');
        return;
      }
    } catch {
      // not authenticated
    }
    setChecking(false);
  }, [navigate]);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes('session_id=')) {
      setChecking(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#00A8B5] to-[#2DD4BF] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#00A8B5] to-[#2DD4BF] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <img 
              src={LOGO_URL} 
              alt="Rota Continental" 
              className="h-16 w-16 rounded-lg object-cover shadow-lg"
            />
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Rota Continental</h1>
          <p className="text-slate-600">Painel Administrativo</p>
        </div>

        <Button
          onClick={handleGoogleLogin}
          className="w-full bg-[#00A8B5] hover:bg-[#008C99] text-white font-semibold py-6 text-lg rounded-full"
          data-testid="google-login-button"
        >
          <LogIn className="w-5 h-5 mr-2" />
          Entrar com Google
        </Button>

        <p className="text-xs text-center text-slate-400 mt-4">
          Acesso restrito a administradores autorizados.
        </p>

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-sm text-slate-600 hover:text-[#00A8B5] transition"
            data-testid="back-to-home"
          >
            Voltar para o site
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
